import { LayoutRenderLayoutItemOptions } from '../../../models/cv-layout-render.model';

export class SmartTagsOptions extends LayoutRenderLayoutItemOptions {
	groupKey?: string; // Key in the data to group the smartTags
	filter?: string[];
	include?: string[];
	exclude?: string[];
	externalProcess?: boolean;
	version?: string;

	constructor() {
		super();
		this.groupKey = null;
		this.filter = [];
		this.include = [];
		this.exclude = [];
		this.externalProcess = false;
	}
}
